import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import OpcDaWriterTableService from '../service/OpcDaWriterTableService';

const config = {
	key: 'opcDaWriterTable',
	topic: 'opcDaWriter',
	service: OpcDaWriterTableService,
	editFormState: item => `/opc-da-writer/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['exportData', 'modify', 'delete'],
	exportData: {
		tooltip: 'Export to XLSX',
		link: item => `${nBossConnection.basePath}opcDaWriterTableControl/exportToXlsx?id=${item.id}`
	},
	columns: [
		{
			key: 'name'
		}
	]
};

function OpcDaWriterTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('opcDaWriterTable', reducer('opcDaWriterTable'))(OpcDaWriterTable);